import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7295ddc1&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7295ddc1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2023/thShop/thShopAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7295ddc1')) {
      api.createRecord('7295ddc1', component.options)
    } else {
      api.reload('7295ddc1', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7295ddc1&scoped=true&", function () {
      api.rerender('7295ddc1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/member/memberLimitArea/index.vue"
export default component.exports